import Vue from 'vue'
import Ticket from '../pages/ticket.vue'
import Buefy from 'buefy'
import "../css/buefy.scss"

Vue.use(Buefy)

new Vue({
  el     : '#ticket',
  render : h => h(Ticket)
})
